module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-text-field-multiline"
  }, [_c('textarea', {
    ref: "textareaHidden",
    staticClass: "mu-text-field-textarea-hide mu-text-field-input",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "textarea",
    staticClass: "mu-text-field-input mu-text-field-textarea",
    class: _vm.normalClass,
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.handleChange,
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ffcafe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/textField/enhancedTextarea.vue
// module id = 3023
// module chunks = 1